export default {
  disabled: '注销',
  enable: '启用',
  addStore: '新增门店',
  storeCode: '门店编号',
  storeDesc: '门店名称',
  storeStatus: '门店状态',
  createTime: '创建时间',
  updateTime: '更新时间',
  disabledStoreDataTip: '您确定要注销此门店吗？',
  enableStoreDataTip: '您确定要启用此门店吗？',
  disabledTunnelMachineDataTip: '您确定要注销此通道机吗？',
  enableTunnelMachineDataTip: '您确定要启用此通道机吗？',
  error_1001: '门店编号重复',
  error_10011: '门店编号不能为空',
  error_title_1002: '通道机重复',
  error_1002: '此通道机编号或IP地址已存在系统中。',
  error_10021: '通道机编号不能为空',
  error_10022: '通道机编号格式不正确',
  error_10023: 'id不为空',
  error_10024: '请输入正确的ip，不能为空',
  error_10025: '请输入正确的仓库，它不是空的',
  error_10026: '请输入正确的Site类型，不能为空',
  error_10027: '请输入正确的Site名称，不能为空',
  error_1003: '通道机IP地址不能为空',
  error_10031: '通道机IP地址重复',
  addTunnelMachine: '新增通道机',
  editTunnelMachine: '编辑通道机',
  tunnelMachineCode: '通道机编号',
  tunnelMachineIp: 'IP地址',
  tunnelMachineStatus: '通道机状态',
  checkIpv4Format: '请输入正确的IPv4地址',
  plant: '仓库编号',
  siteType: 'Site 类型',
  siteName: 'Site 名称',
  createDate: '创建时间',
  vendor: '供应商'
}
